module.exports = __webpack_public_path__ + "static/img/mouth_06.bfcc914.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/mouths/thumbnail/mouth_06.png
// module id = PuTA
// module chunks = 0